import React, { useContext, useEffect } from 'react';
import { Context } from "../contexts/AppContext";
import VideoThumbnailExtractor from './VideoThumbnailExtractor';
import { getData, putData } from '../../lib/utils';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

function LinkMediaSideNav() {
  const { galleryId } = useParams();
  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  useEffect(() => {
    const fetchData = async () => {
      const json = await getData(
        `galleries/gallery/${galleryId}/selected-videos`,
        {}
      );
      if (json) {
        setAppState((prevState) => ({
          ...prevState,
          selectedVideos: json,
        }));
      }
    };
    fetchData();
  }, [galleryId, setAppState]);

  const btnHandler = () => {
    setAppState((prevState) => ({
      ...prevState,
      modalData: {
        ...prevState.modalData,
        type: "AddMediaModal",
        isOpen: true,
        galeryUpdate: true,
        openFrom: "addMedia",
      },
    }));
  };

  const deleteFromLinkMedia = async (itemId, index) => {
    const updatedVideos = appState?.selectedVideos
      .filter((item) => item._id !== itemId)
      .map((item) => item._id);

    const _json = await putData(
      `galleries/gallery/${galleryId}/selected-videos`,
      { selectedVideoIds: updatedVideos }
    );

    if (_json) {
      setAppState((prevState) => ({
        ...prevState,
        currentGalleryData: {
          ...(prevState.currentGalleryData || {}),
          selectedVideos: updatedVideos,
        },
        selectedVideos: _json.selectedVideos,
      }));
    }

    localStorage.removeItem(`thumb_${itemId}`);
  };

  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    const items = [...appState.selectedVideos];
    const [movedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, movedItem);

    setAppState((prev) => ({
      ...prev,
      selectedVideos: items,
      currentGalleryData: {
        ...prev.currentGalleryData,
        selectedVideos: items.map((v) => v._id),
      },
    }));

    const sortedIds = items.map((v) => v._id);
    await putData(
      `galleries/gallery/${galleryId}/selected-videos`,
      { selectedVideoIds: sortedIds }
    );
  };

  return (
    <div className="w-[280px] bg-[#e7eaee] h-full p-2">
      {/* Add Media Button */}
      <div className="flex w-full items-start justify-center bg-[#e7eaee] rounded-lg p-4">
        <button
          onClick={btnHandler}
          className="w-[70%] max-w-xs px-6 py-3 text-white bg-gray-800 rounded-lg hover:bg-gray-700 active:scale-95 transition duration-300 ease-in-out shadow-md"
        >
          + Add Media
        </button>
      </div>
      

      {/* Drag and Drop Context */}
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="videosDroppable">
          {(provided) => (
            <div
              className="w-full flex flex-col items-center  h-[calc(100vh-150px)] overflow-auto"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {appState?.selectedVideos?.map((item, index) => {
                const storedThumb = localStorage.getItem(`thumb_${item._id}`);

                return (
                  <Draggable key={item._id} draggableId={item._id} index={index}>
                    {(provided) => (
                      <div
                        className="relative bg-gray-800 w-4/5 min-w-[200px] justify-center transition duration-300 p-2 mb-3 rounded-lg shadow-md"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                      >
                        {/* ✅ Drag handle over thumbnail */}
                        <div
                          {...provided.dragHandleProps}
                          className="absolute top-2 right-2 bg-black/40 text-white text-xs px-4 py-2 rounded cursor-grab select-none z-10"
                          title="Drag to reorder"
                        >
                          ☰
                        </div>

                        {/* ✅ Thumbnail */}
                        {storedThumb ? (
                          <img
                            src={storedThumb}
                            alt={item.title}
                            className="w-full h-auto rounded"
                          />
                        ) : (
                          
                            <img
 
                src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${item.thumbnail}`}
                alt="thumbnail"
                className="w-full h-auto object-cover rounded-lg"
                loading="lazy"
                onError={(e) => {
                 e.currentTarget.style.display = "none";
             

                
                }} />
                        )}

                        {/* ✅ Title + Delete */}
                        <div className="bg-white relative rounded-b-md">
                          <h2 className="px-4 font-bold py-1 text-gray-800">
                            {item.title}
                          </h2>
                          <FontAwesomeIcon
                            onClick={(e) => {
                              e.stopPropagation();
                              deleteFromLinkMedia(item._id, index);
                            }}
                            icon={faTrash}
                            className="absolute bottom-2 right-2 cursor-pointer"
                            style={{ color: "#854d0e" }}
                          />
                        </div>
                      </div>
                    )}
                  </Draggable>
                );
              })}

              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}

export default LinkMediaSideNav;
